import React, {useContext} from "react"
import {Text, View} from "@react-pdf/renderer"
import {baseStyles} from "../styles"
import {PDFContext} from "../BasePDF"

// Top bar: blue company-name title on the left, "{Worksheet name} ·
// {date}" right-aligned, then a hairline divider underneath. Customer
// PDFs pass `pdfName="Customer Disclosure"` and Dealer PDFs pass
// `pdfName="Dealer Worksheet"`.
export const HeaderPDF = ({pdfName, companyName}) => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    const dateStr = new Date().toLocaleDateString('en-US', {
        year:  'numeric',
        month: '2-digit',
        day:   '2-digit',
    })

    return (
        <View style={baseStyles.topbar}>
            <View style={baseStyles.topbarInner}>
                <Text style={baseStyles.topbarTitle}>
                    {(companyName || '').toUpperCase()}
                </Text>
                <Text style={baseStyles.topbarSubtitle}>
                    {pdfName} · {dateStr}
                </Text>
            </View>
            <View style={baseStyles.topbarBorder}/>
        </View>
    )
}
